import React, { useState } from 'react'
import { Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { useForm } from 'react-hook-form'
import SweetAlert from 'sweetalert2'

import UserService from '../../../network/services/user'
import { useTranslation } from 'react-i18next'

const ChangePasswordForm = () => {
  const { t } = useTranslation()
  const { register, handleSubmit, errors, reset, formState } = useForm()
  const [error, setError] = useState(null)
  const { isSubmitting } = formState

  const handleChangePassword = async (data) => {
    // console.log(data)
    try {
      if (data !== '') {
        const result = await UserService.changePassword(data)
        // console.log(result)

        if (result.user) {
          reset()
          setError(null)
           SweetAlert.fire({
            showClass: {
              popup: 'animate__animated animate__backInUp'
            },
            hideClass: {
              popup: 'animate__animated animate__backOutDown'
            },
            showClass: {
              popup: 'animate__animated animate__backInUp'
            },
            hideClass: {
              popup: 'animate__animated animate__backOutDown'
            },
            title: t("user.PasswordChangedSuccessfully"),
            icon: 'success', 
          })
        }
      } else {
        errors.showMessages()
      }
    } catch (error) {
      console.log(error)
      setError(error.message)
    }
  }

  return (
    <Form className="theme-form" onSubmit={handleSubmit(handleChangePassword)}>
      <Row>
        <Col>
          <FormGroup>
            <Label><p style={{ fontSize: '18px' }}>{t("user.OldPassword")}</p></Label>
            <Input
              className="form-control"
              type="password"
              name="password"
              placeholder="eg. abcde12345"
              innerRef={register({ required: true })}
              style={{
                backgroundColor: 'white',
                height: '60px',
                borderRadius: '14px'
              }}
            />
            <span style={{ color: 'red' }}>{errors.password && t("user.OldpasswodRequired")}</span>
          </FormGroup>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col>
          <FormGroup>
            <Label><p style={{ fontSize: '18px' }}>{t("user.NewPassword")}</p></Label>
            <Input
              className="form-control"
              type="password"
              name="new_password"
              placeholder="eg. abcde12345"
              innerRef={register({ required: true })}
              style={{
                backgroundColor: 'white',
                height: '60px',
                borderRadius: '14px'
              }}
            />
            <span style={{ color: 'red' }}>
              {errors.new_password && t("user.NewpasswordRequired")}
            </span>
          </FormGroup>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col>
          <FormGroup>
            <Label><p style={{ fontSize: '18px' }}>{t("user.ConfirmPassword")}</p></Label>
            <Input
              className="form-control"
              type="password"
              name="new_password_confirmation"
              placeholder="eg. abcde12345"
              innerRef={register({ required: true })}
              style={{
                backgroundColor: 'white',
                height: '60px',
                borderRadius: '14px'
              }}
            />
            <span style={{ color: 'red' }}>
              {errors.new_password_confirmation && t("user.ConfirmPasswordRequire")}
            </span>
            {error != null && <span style={{ color: 'red' }}>{error}</span>}
          </FormGroup>
        </Col>
      </Row>
      <Row style={{ marginTop: '40px' }}>
        <Col>
          <FormGroup className="mb-0">
            <Button color="primary" className="mt-2" disabled={isSubmitting} style={{ float: 'left', borderRadius: '15px', minWidth: '215px', height: '50px', color: 'black', fontSize: '18px' }}>
              {isSubmitting ? t("user.Loading") : t("user.ChangePassword")}
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  )
}

export default ChangePasswordForm
